import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";

import Tabbar from "../../assets/tabbar-ios.png";
import TabbarServices from "../../assets/tabbar-ios-services.png";

import News1PaddingRounded from "../../assets/news1-padding-rounded.png";
import News1Padding from "../../assets/news1-padding.png";
import News1 from "../../assets/news1.png";

import News2PaddingRounded from "../../assets/news2-padding-rounded.png";
import News2Padding from "../../assets/news2-padding.png";
import News2 from "../../assets/news2.png";

import News3PaddingRounded from "../../assets/news3-padding-rounded.png";
import News3Padding from "../../assets/news3-padding.png";
import News3 from "../../assets/news3.png";

import News4Padding from "../../assets/news4-padding.png";
import News4 from "../../assets/news4.png";

import News5PaddingRounded from "../../assets/news5-padding-rounded.png";
import News5Padding from "../../assets/news5-padding.png";
import News5 from "../../assets/news5.png";

import NewsService1PaddingRounded from "../../assets/newsService1-padding-rounded.png";
import NewsService1Padding from "../../assets/newsService1-padding.png";
import NewsService1 from "../../assets/newsService1.png";

import NewsService2PaddingRounded from "../../assets/newsService2-padding-rounded.png";
import NewsService2Padding from "../../assets/newsService2-padding.png";
import NewsService2 from "../../assets/newsService2.png";

import NewsService3PaddingRounded from "../../assets/newsService3-padding-rounded.png";
import NewsService3Padding from "../../assets/newsService3-padding.png";
import NewsService3 from "../../assets/newsService3.png";

import NewsService4Padding from "../../assets/newsService4-padding.png";
import NewsService4 from "../../assets/newsService4.png";

import NewsService5PaddingRounded from "../../assets/newsService5-padding-rounded.png";
import NewsService5Padding from "../../assets/newsService5-padding.png";
import NewsService5 from "../../assets/newsService5.png";

import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";

import { CircularProgress } from "@mui/material";
import { UserContext } from "../../context/UserContext";

import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";

import EmptyIphone from "../../assets/iphone-empty.png";

const useStyles = makeStyles({
	iphoneContainer: {
		"& *": {
			userDrag: "none",
		},
	},
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardPageInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardOptions: {
		display: "flex",
		flexDirection: "column",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
});

export default function News({ drawerWidth }) {
	const classes = useStyles();
	const [news, setNews] = useState(null);
	const [loading, setLoading] = useState(false);
	const [showRoundedImage, setShowRoundedImage] = useState(false);
	const [showShare, setShowShare] = useState(false);
	const [showPadding, setShowPadding] = useState(false);

	const { user } = useContext(UserContext);
	const { t } = useTranslation();

	const alert = useAlert();

	const service = user.app.appType === "Services";

	const allNews = [
		{
			value: "news1",
			label: (
				<>
					<b>{t("news.style")} 1</b>: {t("news.news1")}
				</>
			),
		},
		{
			value: "news2",
			label: (
				<>
					<b>{t("news.style")} 2</b>: {t("news.news2")}
				</>
			),
		},
		{
			value: "news3",
			label: (
				<>
					<b>{t("news.style")} 3</b>: {t("news.news3")}
				</>
			),
		},
		{
			value: "news4",
			label: (
				<>
					<b>{t("news.style")} 4</b>: {t("news.news4")}
				</>
			),
		},
		{
			value: "news5",
			label: (
				<>
					<b>{t("news.style")} 5</b>: {t("news.news5")}
				</>
			),
		},
	];

	const getNewsData = async () => {
		setLoading(true);
		try {
			const res = await axios.get(ADMIN_URL + "creators", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setNews(
				allNews.find((item) => {
					return item.value === res.data.newsType;
				})
			);
			setShowPadding(res.data.newsShowPadding);
			setShowRoundedImage(res.data.newsRoundedImage);
			setShowShare(res.data.newsShowShare);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	useEffect(() => {
		getNewsData();
	}, []);

	const saveNewsData = async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					newsType: news.value,
					newsRoundedImage: showRoundedImage,
					newsShowPadding: showPadding,
					newsShowShare: showShare,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const getImage = () => {
		let image = EmptyIphone;
		if (news) {
			if (news.value === "news1") {
				if (showPadding && showRoundedImage) {
					image = service ? NewsService1PaddingRounded : News1PaddingRounded;
				} else if (showPadding && !showRoundedImage) {
					image = service ? NewsService1Padding : News1Padding;
				} else {
					image = service ? NewsService1 : News1;
				}
			} else if (news.value === "news2") {
				if (showPadding && showRoundedImage) {
					image = service ? NewsService2PaddingRounded : News2PaddingRounded;
				} else if (showPadding && !showRoundedImage) {
					image = service ? NewsService2Padding : News2Padding;
				} else {
					image = service ? NewsService2 : News2;
				}
			} else if (news.value === "news3") {
				if (showPadding && showRoundedImage) {
					image = service ? NewsService3PaddingRounded : News3PaddingRounded;
				} else if (showPadding && !showRoundedImage) {
					image = service ? NewsService3Padding : News3Padding;
				} else {
					image = service ? NewsService3 : News3;
				}
			} else if (news.value === "news4") {
				if (showPadding) {
					image = service ? NewsService4Padding : News4Padding;
				} else {
					image = service ? NewsService4 : News4;
				}
			} else if (news.value === "news5") {
				if (showPadding && showRoundedImage) {
					image = service ? NewsService5PaddingRounded : News5PaddingRounded;
				} else if (showPadding && !showRoundedImage) {
					image = service ? NewsService5Padding : News5Padding;
				} else {
					image = service ? NewsService5 : News5;
				}
			}

			return image;
		}
	};

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />

			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{
								fontSize: 14,
								borderBottom: "1px solid #f0f0f0",
								minHeight: "35px",
								marginBottom: "20px",
								marginLeft: "-20px",
								marginRight: "-20px",
								padding: "0px 20px 20px",
							}}
							color="text.secondary"
							gutterBottom
						>
							{t("news.title")}
						</Typography>
						<Box
							className={classes.cardPageInfo}
							sx={{
								flexFlow: {
									xs: "column-reverse",
									sm: "column-reverse",
									md: "row",
								},
							}}
						>
							<Box
								className={classes.cardOptions}
								sx={{
									minWidth: {
										xs: 0,
										sm: 0,
										md: 400,
									},
								}}
							>
								<RadioGroup
									aria-labelledby="demo-radio-buttons-group-label"
									value={news && news.value}
									name="radio-buttons-group"
									onChange={(e) => {
										setNews(allNews.find((p) => p.value === e.target.value));
									}}
								>
									{allNews.map((item) => {
										return (
											<FormControlLabel
												key={item.value}
												value={item.value}
												control={
													<Radio
														disabled={[
															"building",
															"built",

															"publishing",
															"published",
															"inviting",
														].find(
															(status) =>
																status ===
																(user.app.appStatuses.length === 0
																	? ""
																	: user.app.appStatuses.length > 0 &&
																	  user.app.appStatuses[0].status)
														)}
													/>
												}
												label={item.label}
												sx={{
													marginBottom: {
														xs: 1,
														sm: 1,
														md: 0,
													},
												}}
											/>
										);
									})}
								</RadioGroup>
								<>
									<Typography
										sx={{
											fontSize: 12,
											marginTop: 2,
											marginBottom: 0,
											fontWeight: 700,
											textTransform: "uppercase",
										}}
										color="text.secondary"
										gutterBottom
									>
										{t("general.chooseOptions")}
									</Typography>

									{/*<FormControlLabel
										control={
											<Checkbox
												checked={showShare}
												onChange={(e) => {
													setShowShare(!showShare);
												}}
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("news.showShare")}
									/>*/}
									{showPadding && news.value !== "news4" && (
										<FormControlLabel
											control={
												<Checkbox
													checked={showRoundedImage}
													onChange={(e) => {
														setShowRoundedImage(!showRoundedImage);
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={t("news.roundedImage")}
										/>
									)}
									<FormControlLabel
										control={
											<Checkbox
												checked={showPadding}
												onChange={(e) => {
													if (showPadding) {
														setShowRoundedImage(false);
													}
													setShowPadding(!showPadding);
												}}
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("news.showPadding")}
									/>
								</>
							</Box>

							<div
								className={classes.iphoneContainer}
								style={{ position: "relative" }}
							>
								<img
									src={getImage()}
									alt="iphone"
									onMouseOver={() => {}}
									onMouseLeave={() => {}}
									className={classes.iphone}
								/>
								<img
									src={
										user.app.appType === "Services" ? TabbarServices : Tabbar
									}
									alt="tabbar"
									onMouseOver={() => {}}
									onMouseLeave={() => {}}
									className={classes.iphone}
									style={{ position: "absolute", top: 0, left: 0 }}
								/>
								<div
									style={{
										position: "absolute",
										top: 30,
										left: 35,
										backgroundColor: "white",
										width: 20,
										height: 20,
									}}
								></div>
							</div>
						</Box>
					</CardContent>
					{!["inviting", "building", "built", "publishing", "published"].find(
						(status) =>
							status ===
							(user.app.appStatuses.length === 0
								? ""
								: user.app.appStatuses.length > 0 &&
								  user.app.appStatuses[0].status)
					) && (
						<CardActions sx={{ justifyContent: "right" }}>
							<Button
								variant="contained"
								onClick={() => {
									saveNewsData();
								}}
								size="small"
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("general.save")}
							</Button>
						</CardActions>
					)}
				</>
			</Card>
		</Box>
	);
}
